export default __webpack_public_path__ + "static/media/bbank-bnb-closed-logo.8d39f6b9.svg";